import { CultureInfo } from '../../../../core/culture-info';
import { Observable } from 'rxjs';
import { HttpEvent } from '@angular/common/http';
import { CategoryNaturalKey } from '../../../../documents';

export class MethodUploadOptions {
    constructor(
        public readonly categoryId: CategoryNaturalKey,
        public readonly files: Map<File, CultureInfo>,
        public readonly documentMetadata: { [metadataName: string]: any },
        public readonly onSuccessfulUpload: () => void
    ) { }
}

export class CustomMethodUploadOptions {
    constructor (
        public readonly customUploadMethod: () => Observable<HttpEvent<Object>>,
        public readonly onSuccessfulUpload: () => void = () => {}
    ) { }
}